import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Element } from '../Element';
import { FieldType, SectionType } from '../types';

interface Props {
  config: SectionType;
  locale: string;
  externalData: any;
}

const Signatures = ({
  config,
  locale,
  externalData,
}: Props) => {
  const classes = useStyles();

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <h3
              style={{ fontSize: 22, textAlign: 'center' }}
              className={classes.sectionHeader}
            >
              {config?.title?.config?.displayLabel?.en || ''}
            </h3>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4}>
              {config.fields.map((field: FieldType, index: number) => (
                <Element
                  item={field}
                  key={`signatures.${index}`}
                  locale={locale}
                  externalData={externalData}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export { Signatures };

const useStyles = makeStyles(() => ({
  sectionHeader: {
    fontWeight: 500,
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: 22,
    textAlign: 'center',
  },
}));
